/* =====================================================================
   VIRALITY SCHOOL - WEBINAR PAGE CONFIG
   Everything you might want to edit lives in this file.
   Change the text between the quotes, save, and the page updates.
   ===================================================================== */

export const CONFIG = {
  // 1. Your Vimeo video link (unlisted links keep their /hash at the end)
  VIMEO_URL: "https://vimeo.com/1235092477/cc0b96212c",

  // 1b. The path the page lives at. Any other path redirects here.
  PAGE_PATH: "/Meta-workshop-11-0ct",

  // 2. Your Google Apps Script Web App URL. It ends with /exec
  APPS_SCRIPT_URL: "https://script.google.com/macros/s/AKfycbyJGUrRdDEwTxnuqYfkn94LGn9KTyF_exT-gomlQYBQFczw5kEz5MRo8mz46bg54yIw/exec",

  // 3. Watch time is still tracked and sent with enquiries as "minutesWatched",
  //    but the next-step options are shown immediately (no unlock timer).

  // 4. Registration gate text
  gate: {
    badge: "Webinar replay",
    // Shown in the header, the registration popup and above the video
    expiryText: "This recording is available until 20 October 2026",
    headline: "Meta Ads with AI Workshop Recording. By Virality School.",
    subheadline:
      "Press play to start the complete 4-hour workshop recording from Virality School. We only use your details to send you the follow-up resources.",
    playLabel: "Play the replay",
    formTitle: "Tell us who is watching",
    formSubtitle: "Fill in your details once and the replay starts right away.",
    nameLabel: "Full name",
    phoneLabel: "Phone number",
    emailLabel: "Email address",
    buttonText: "Watch the replay",
    buttonLoadingText: "Saving your seat...",
    errorText: "We could not save your registration. Please check your connection and try again.",
    retryButtonText: "Try again",
  },

  // 5. Video page text. {name} is replaced with the viewer's first name.
  video: {
    greeting: "Hi {name}, your replay is ready.",
    note: "Your next steps are ready below the video. Pick the option that fits you best whenever you are ready.",
  },

  // 5b. Course brochure button, shown directly under the Enroll button.
  //     The PDF lives in frontend/public/brochure/
  brochure: {
    buttonText: "Download Course Brochure",
    file: "/brochure/Meta-Ads-AI-Challenge.pdf",
  },

  // 6. Next-step section and sticky bar text
  nextSteps: {
    title: "Choose your next step",
    subtitle: "Pick the option that fits you best and our team will take it from there.",
    stickyText: "Ready to take the next step?",
    stickyButtonText: "Choose your next step",
  },

  // 7. The three option cards.
  //    url: leave as "" to open the enquiry popup.
  //    Paste a link (payment page, Calendly, WhatsApp) to open it in a new tab instead.
  options: [
    {
      id: "enroll",
      title: "Enroll now",
      description: "Pay the full amount now and secure your seat in the Virality School program.",
      buttonText: "Enroll now",
      featured: true,
      url: "https://rzp.io/rzp/PJSKYrf",
    },
    {
      id: "book",
      title: "Book a slot",
      description: "Reserve your seat with a booking amount today and pay the balance later.",
      buttonText: "Book a slot",
      featured: false,
      url: "https://rzp.io/rzp/HWkCJT2",
    },
    {
      id: "talk",
      title: "Talk to our team",
      description: "Have a question first? Fill in a short form and our team will get back to you.",
      buttonText: "Ask a question",
      featured: false,
      url: "https://forms.gle/7L7342sjYUM6AKWf8",
    },
  ],

  // 8. Enquiry popup text
  enquiry: {
    title: "Almost done",
    subtitle: "Confirm your details and our team will call you.",
    messageLabel: "Best time to call, or your question",
    messagePlaceholder: "For example: weekday evenings after 6 pm",
    buttonText: "Send request",
    buttonLoadingText: "Sending...",
    confirmationTitle: "Request received",
    confirmationText: "Thank you, {name}. A Virality School team member will call you shortly.",
    closeButtonText: "Back to the replay",
  },
};
